import { Box } from "atoms/grid";
import { Col, Container, Row } from "atoms/grid-new";
import { isProduction } from "lib/env";
import { useEffect, useState } from "react";
import styled from "styled-components";

const G = 71;

const FixedContainer = styled(Container)`
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  pointer-events: none;
`;

const RedBox = styled(Box)`
  background-color: rgba(255, 0, 0, 0.04);
  height: 100%;
  width: 100%;
`;

const ColumnContainer = () => {
  const [show, setShow] = useState();

  const handleKeydown = (e) => {
    if (e.keyCode === G && e.ctrlKey) {
      setShow(!show);
    }
  };

  useEffect(() => {
    if (window.location.hostname === "localhost") {
      document.addEventListener("keydown", handleKeydown);
      console.info("Press Ctrl + G to toggle grid");
    }

    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  if (
    !process.browser ||
    isProduction() ||
    window.location.origin === "https://getpenfold.com"
  ) {
    return null;
  }

  return show ? (
    <Row height="100%">
      <Col span={[3, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[3, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[3, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[3, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[, , 1]} height="100%">
        <RedBox />
      </Col>
      <Col span={[1]} height="100%">
        <RedBox />
      </Col>
    </Row>
  ) : null;
};

const GridOverlay = () => (
  <FixedContainer>
    <ColumnContainer />
  </FixedContainer>
);

export default GridOverlay;
